import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import messages from "./messages";
import { Close } from "@material-ui/icons";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import RefrezhButton from "components/RefrezhButton";

const useStyles = makeStyles(theme => ({
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
}));

function DeletePatientModal({
  isOpen = false,
  onClose,
  onConfirm,
  dataCy,
  deleteMessage,
}) {
  const classes = useStyles();

  return (
    <Dialog open={isOpen} onClose={onClose} data-cy={dataCy}>
      <DialogTitle>
        <div className={classes.header}>
          <div>
            <FormattedMessage {...messages.delete_patient_title} />
          </div>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <p>
          <FormattedMessage {...messages.delete_patient_content} />
        </p>
        <Typography align="center" color="error" data-cy="errorMsg">
          {deleteMessage}
        </Typography>
      </DialogContent>
      <DialogActions>
        <div data-cy="cancelButton">
          <RefrezhButton onClick={onClose}>
            <FormattedMessage {...messages.delete_patient_cancel} />
          </RefrezhButton>
        </div>
        <div data-cy="confirmButton">
          <RefrezhButton onClick={onConfirm}>
            <FormattedMessage {...messages.delete_patient_confirm} />
          </RefrezhButton>
        </div>
      </DialogActions>
    </Dialog>
  );
}

DeletePatientModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  deleteMessage: PropTypes.any,
};

export default DeletePatientModal;
